import NewButton from './new';
import EditButton from './edit';
import DeleteButton from './delete';
import RefreshButton from './refresh';
import ExecuteButton from './execute';
import UnExecuteButton from './unexecute';
import PeriodButton from './period';
import FiltersButton from './filters';
import ShowDeletedToggler from './show_deleted_toggler';
import AddRowButton from './addRow';
import DeleteRowButton from './deleteRow';
import ExportXLSButton from './exportxls';

const Buttons = {
  NewButton,
  EditButton,
  DeleteButton,
  RefreshButton,
  ExecuteButton,
  UnExecuteButton,
  PeriodButton,
  FiltersButton,
  ShowDeletedToggler,
  AddRowButton,
  DeleteRowButton,
  ExportXLSButton,
};

export default Buttons;
